export default __webpack_public_path__ + "69952d9b3a5a2ac8bccf50edfa45dc56.jpg";